import { markAgentQuestionAnswered } from './markAgentQuestionAnswered.js'
import {
  isAgentQuestionFreeTextOption,
  resolveAgentQuestionOptionSendText,
} from './resolveAgentQuestionOptionSendText.js'

export function handleAgentQuestionConfirm(p) {
  const { optionId, freeText, active, displayThreadId, setMessagesByThreadId, handleSendMessage } = p
  if (!active || !displayThreadId) return

  const { assistantMessageId, question } = active

  if (isAgentQuestionFreeTextOption(optionId, question)) {
    const text = String(freeText ?? '').trim()
    if (!text) return
    setMessagesByThreadId((prev) =>
      markAgentQuestionAnswered(prev, {
        tid: displayThreadId,
        assistantMessageId,
        selectedAnswer: text,
      }),
    )
    handleSendMessage({ text, files: [] })
    return
  }

  let sendText = resolveAgentQuestionOptionSendText(optionId, question)
  const option = question.options.find((o) => o.id === optionId)
  if (!sendText && question.kind === 'designDnaFigmaPublish') {
    sendText = option?.label ?? null
  }
  if (!sendText) return
  const selectedAnswer = option?.label ?? sendText

  setMessagesByThreadId((prev) =>
    markAgentQuestionAnswered(prev, {
      tid: displayThreadId,
      assistantMessageId,
      selectedAnswer,
    }),
  )
  handleSendMessage({ text: sendText, files: [] })
}

/**
 * @param {{
 *   messages: Array<{ id?: string, role?: string, agentQuestion?: { status?: string, prompt?: string } }>,
 *   displayThreadId: string | null,
 *   setMessagesByThreadId: (updater: (prev: Record<string, unknown[]>) => Record<string, unknown[]>) => void,
 *   selectedAnswer: string,
 * }} p
 */
